import { QUESTION_TYPES } from "./questionTypes";

export const getDefaultAnswer = (correct = false, text = "") => ({
  id: `${Math.random()}`,
  answerText: text,
  answerTextTranslations: [],
  correct,
  feedbackText: "",
  feedbackTextTranslations: [],
});

export const getDefaultQuestion = () => ({
  id: `${Math.random()}`,
  questionText: "Untitled Question", 
  type: QUESTION_TYPES.singleCorrectAnswer,
  questionTextTranslations: [],
  answers: [
    getDefaultAnswer(true, "Option 1"), 
    getDefaultAnswer(false, "Option 2")
  ],
});